/**
 * @generated SignedSource<<bcc046dce118ab4caa0d861eb68e30e7>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currentUserPermissions",
        "storageKey": null
    }, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignmentTypeId",
        "storageKey": null
    }, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/),
            (v6 /*: any*/)
        ],
        "type": "ISchedulableEntity",
        "abstractKey": "__isISchedulableEntity"
    }, v8 = [
        (v2 /*: any*/)
    ], v9 = {
        "kind": "InlineFragment",
        "selections": (v8 /*: any*/),
        "type": "Node",
        "abstractKey": "__isNode"
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "employeeId",
        "storageKey": null
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": (v8 /*: any*/),
                "storageKey": null
            }
        ],
        "type": "SchedulableUser",
        "abstractKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    }, v14 = [
        (v13 /*: any*/),
        (v2 /*: any*/)
    ], v15 = {
        "alias": null,
        "args": null,
        "concreteType": "AssignmentType",
        "kind": "LinkedField",
        "name": "assignmentType",
        "plural": false,
        "selections": (v14 /*: any*/),
        "storageKey": null
    }, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assignedEntityId",
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "start",
        "storageKey": null
    }, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "end",
        "storageKey": null
    }, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVacant",
        "storageKey": null
    }, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    }, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fullName",
        "storageKey": null
    }, v23 = {
        "alias": null,
        "args": null,
        "concreteType": "ScheduleShiftAssetValidation",
        "kind": "LinkedField",
        "name": "assetValidations",
        "plural": true,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "SchedulableAsset",
                "kind": "LinkedField",
                "name": "schedulableAsset",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Asset",
                        "kind": "LinkedField",
                        "name": "asset",
                        "plural": false,
                        "selections": [
                            (v2 /*: any*/),
                            (v21 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "assetNumber",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "validateProficiency",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    (v2 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "SchedulableUser",
                "kind": "LinkedField",
                "name": "schedulableUser",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            (v22 /*: any*/),
                            (v2 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    (v2 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "AssignmentType",
                "kind": "LinkedField",
                "name": "userAssignmentType",
                "plural": false,
                "selections": (v14 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "AssetProficiencyValidation",
                "kind": "LinkedField",
                "name": "assetProficiency",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isValid",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
    }, v25 = [
        (v21 /*: any*/),
        (v2 /*: any*/)
    ], v26 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    }, v27 = {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    }, v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    }, v29 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstname",
        "storageKey": null
    }, v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastname",
        "storageKey": null
    }, v31 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timestamp",
        "storageKey": null
    }, v32 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
    }, v33 = [
        (v2 /*: any*/),
        (v29 /*: any*/),
        (v30 /*: any*/)
    ], v34 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    }, v35 = [
        {
            "kind": "Literal",
            "name": "order",
            "value": {
                "timestamp": "DESC"
            }
        }
    ], v36 = {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "byUser",
        "plural": false,
        "selections": [
            (v11 /*: any*/),
            (v22 /*: any*/),
            (v2 /*: any*/)
        ],
        "storageKey": null
    }, v37 = [
        (v2 /*: any*/),
        (v13 /*: any*/)
    ], v38 = [
        (v5 /*: any*/),
        {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isSchedulableEntity"
        },
        (v7 /*: any*/),
        (v9 /*: any*/)
    ], v39 = [
        (v17 /*: any*/),
        (v18 /*: any*/),
        (v28 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ResetScheduleShiftConfirmResetScheduleShiftMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ResetScheduleShiftPayload",
                    "kind": "LinkedField",
                    "name": "resetScheduleShift",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfScheduleShift",
                            "kind": "LinkedField",
                            "name": "shiftEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleShift",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleShiftInformationTab_ScheduleShift"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "useScheduleShiftAttachments_scheduleShift"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "useScheduleShiftNotes_scheduleShift"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleShiftHistory_scheduleShift"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleShiftChangeTab_shift"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ResetScheduleShiftConfirmResetScheduleShiftMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ResetScheduleShiftPayload",
                    "kind": "LinkedField",
                    "name": "resetScheduleShift",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfScheduleShift",
                            "kind": "LinkedField",
                            "name": "shiftEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScheduleShift",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Schedule",
                                            "kind": "LinkedField",
                                            "name": "schedule",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                (v2 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleAssignmentTypeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "assignmentTypes",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleAssignmentTypeEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleAssignmentType",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v4 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ScheduleAssignmentTypeResourceConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "resources",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ScheduleAssignmentTypeResourceEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "ScheduleAssignmentTypeResource",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": null,
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "schedulableEntity",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v5 /*: any*/),
                                                                                                        (v7 /*: any*/),
                                                                                                        (v9 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v2 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "assignedEntity",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v10 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "phone",
                                                                            "storageKey": null
                                                                        },
                                                                        (v11 /*: any*/),
                                                                        (v2 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "SchedulableUser",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "type": "ISchedulableEntity",
                                                    "abstractKey": "__isISchedulableEntity"
                                                },
                                                (v9 /*: any*/),
                                                (v12 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleAssignmentType",
                                            "kind": "LinkedField",
                                            "name": "scheduleAssignmentType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "where",
                                                            "value": {
                                                                "schedulableEntity": {
                                                                    "type": {
                                                                        "eq": "USER"
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "ScheduleAssignmentTypeResourceConnection",
                                                    "kind": "LinkedField",
                                                    "name": "resources",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleAssignmentTypeResource",
                                                            "kind": "LinkedField",
                                                            "name": "nodes",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "schedulableEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v5 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        (v9 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": "resources(where:{\"schedulableEntity\":{\"type\":{\"eq\":\"USER\"}}})"
                                                },
                                                (v2 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v15 /*: any*/),
                                        (v16 /*: any*/),
                                        (v17 /*: any*/),
                                        (v18 /*: any*/),
                                        (v4 /*: any*/),
                                        (v19 /*: any*/),
                                        (v20 /*: any*/),
                                        (v23 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "kind": "LinkedField",
                                            "name": "event",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v21 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v24 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ITaggedItemConnection",
                                            "kind": "LinkedField",
                                            "name": "tags",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ITaggedItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                (v2 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "tagId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Tag",
                                                                    "kind": "LinkedField",
                                                                    "name": "tag",
                                                                    "plural": false,
                                                                    "selections": (v25 /*: any*/),
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v26 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v27 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "filters": null,
                                            "handle": "connection",
                                            "key": "useScheduleShiftTags_tags",
                                            "kind": "LinkedHandle",
                                            "name": "tags"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Break",
                                            "kind": "LinkedField",
                                            "name": "breaks",
                                            "plural": true,
                                            "selections": [
                                                (v18 /*: any*/),
                                                (v17 /*: any*/),
                                                (v28 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleShiftConnection",
                                            "kind": "LinkedField",
                                            "name": "simultaneousScheduleShift",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleShiftEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleShift",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "assignedEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v5 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Asset",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "asset",
                                                                                    "plural": false,
                                                                                    "selections": (v8 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "SchedulableAsset",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v6 /*: any*/),
                                                                                (v10 /*: any*/),
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "User",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "user",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v11 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "type": "SchedulableUser",
                                                                                    "abstractKey": null
                                                                                }
                                                                            ],
                                                                            "type": "ISchedulableEntity",
                                                                            "abstractKey": "__isISchedulableEntity"
                                                                        },
                                                                        (v9 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v15 /*: any*/),
                                                                (v18 /*: any*/),
                                                                (v17 /*: any*/),
                                                                (v19 /*: any*/),
                                                                (v20 /*: any*/),
                                                                (v23 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "IFileConnection",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "IFileEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "contentType",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "directory",
                                                                    "storageKey": null
                                                                },
                                                                (v2 /*: any*/),
                                                                (v21 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "size",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "storageId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "url",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v26 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v27 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "filters": null,
                                            "handle": "connection",
                                            "key": "useScheduleShiftAttachments_attachments",
                                            "kind": "LinkedHandle",
                                            "name": "attachments"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleShiftHistoryVacancyInterest",
                                            "kind": "LinkedField",
                                            "name": "currentVacancyInterestForEntity",
                                            "plural": false,
                                            "selections": [
                                                (v24 /*: any*/),
                                                (v20 /*: any*/),
                                                (v2 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleShiftHistoryVacancyInterestConnection",
                                            "kind": "LinkedField",
                                            "name": "vacancyInterests",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleShiftHistoryVacancyInterest",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "User",
                                                            "kind": "LinkedField",
                                                            "name": "byUser",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Avatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "queryTransform",
                                                                                            "value": "width=300&height=300&mode=crop&scale=both"
                                                                                        }
                                                                                    ],
                                                                                    "kind": "ScalarField",
                                                                                    "name": "url",
                                                                                    "storageKey": "url(queryTransform:\"width=300&height=300&mode=crop&scale=both\")"
                                                                                },
                                                                                (v2 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v10 /*: any*/),
                                                                                (v21 /*: any*/)
                                                                            ],
                                                                            "type": "Asset",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v21 /*: any*/)
                                                                            ],
                                                                            "type": "Company",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v10 /*: any*/),
                                                                                (v29 /*: any*/),
                                                                                (v30 /*: any*/)
                                                                            ],
                                                                            "type": "User",
                                                                            "abstractKey": null
                                                                        }
                                                                    ],
                                                                    "type": "IHaveAvatar",
                                                                    "abstractKey": "__isIHaveAvatar"
                                                                },
                                                                (v11 /*: any*/),
                                                                (v22 /*: any*/),
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "schedulableEntityId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleShift",
                                                            "kind": "LinkedField",
                                                            "name": "scheduleShift",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v16 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v20 /*: any*/),
                                                        (v31 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v32 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleShiftNoteConnection",
                                            "kind": "LinkedField",
                                            "name": "notes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleShiftNoteEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleShiftNote",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "kind": "LinkedField",
                                                                    "name": "byUser",
                                                                    "plural": false,
                                                                    "selections": (v33 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                (v34 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "text",
                                                                    "storageKey": null
                                                                },
                                                                (v5 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v26 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v27 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "filters": null,
                                            "handle": "connection",
                                            "key": "useScheduleShiftNotes_notes",
                                            "kind": "LinkedHandle",
                                            "name": "notes"
                                        },
                                        {
                                            "alias": null,
                                            "args": (v35 /*: any*/),
                                            "concreteType": "ScheduleShiftHistoryConnection",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleShiftHistoryEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v31 /*: any*/),
                                                                        (v24 /*: any*/),
                                                                        (v28 /*: any*/),
                                                                        (v36 /*: any*/)
                                                                    ],
                                                                    "type": "IHaveScheduleShiftHistory",
                                                                    "abstractKey": "__isIHaveScheduleShiftHistory"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "AssignmentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "newAssignmentType",
                                                                            "plural": false,
                                                                            "selections": (v37 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "AssignmentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "previousAssignmentType",
                                                                            "plural": false,
                                                                            "selections": (v37 /*: any*/),
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "ScheduleShiftHistoryAssignmentTypeChange",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "reasonEvent",
                                                                            "plural": false,
                                                                            "selections": (v25 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        (v36 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": null,
                                                                            "kind": "LinkedField",
                                                                            "name": "newAssignedEntity",
                                                                            "plural": false,
                                                                            "selections": (v38 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": null,
                                                                            "kind": "LinkedField",
                                                                            "name": "previouslyAssignedEntity",
                                                                            "plural": false,
                                                                            "selections": (v38 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        (v31 /*: any*/)
                                                                    ],
                                                                    "type": "ScheduleShiftHistoryAssigneeChange",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v36 /*: any*/),
                                                                        (v24 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": null,
                                                                            "kind": "LinkedField",
                                                                            "name": "schedulableEntity",
                                                                            "plural": false,
                                                                            "selections": (v38 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        (v20 /*: any*/),
                                                                        (v31 /*: any*/)
                                                                    ],
                                                                    "type": "ScheduleShiftHistoryVacancyInterest",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v36 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "newEnd",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "newStart",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Break",
                                                                            "kind": "LinkedField",
                                                                            "name": "originalBreaks",
                                                                            "plural": true,
                                                                            "selections": (v39 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Break",
                                                                            "kind": "LinkedField",
                                                                            "name": "newBreaks",
                                                                            "plural": true,
                                                                            "selections": (v39 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "originalEnd",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "originalStart",
                                                                            "storageKey": null
                                                                        },
                                                                        (v31 /*: any*/)
                                                                    ],
                                                                    "type": "ScheduleShiftHistoryTimeChange",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "newEvent",
                                                                            "plural": false,
                                                                            "selections": (v25 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "previousEvent",
                                                                            "plural": false,
                                                                            "selections": (v25 /*: any*/),
                                                                            "storageKey": null
                                                                        },
                                                                        (v36 /*: any*/),
                                                                        (v31 /*: any*/)
                                                                    ],
                                                                    "type": "ScheduleShiftHistoryEventChange",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "newStatus",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "previousStatus",
                                                                            "storageKey": null
                                                                        },
                                                                        (v36 /*: any*/),
                                                                        (v31 /*: any*/)
                                                                    ],
                                                                    "type": "ScheduleShiftHistoryStatusChange",
                                                                    "abstractKey": null
                                                                },
                                                                (v9 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v26 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v32 /*: any*/),
                                                (v27 /*: any*/)
                                            ],
                                            "storageKey": "history(order:{\"timestamp\":\"DESC\"})"
                                        },
                                        {
                                            "alias": null,
                                            "args": (v35 /*: any*/),
                                            "filters": [
                                                "order"
                                            ],
                                            "handle": "connection",
                                            "key": "ScheduleShiftHistory_history",
                                            "kind": "LinkedHandle",
                                            "name": "history"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleShiftChangeRequestConnection",
                                            "kind": "LinkedField",
                                            "name": "changeRequests",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleShiftChangeRequestEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleShiftChangeRequest",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                (v20 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "requestedByUserId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "comment",
                                                                    "storageKey": null
                                                                },
                                                                (v34 /*: any*/),
                                                                (v18 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "kind": "LinkedField",
                                                                    "name": "requestedBy",
                                                                    "plural": false,
                                                                    "selections": (v33 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "respondedAt",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "responseComment",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "kind": "LinkedField",
                                                                    "name": "respondedBy",
                                                                    "plural": false,
                                                                    "selections": (v33 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleShift",
                                                                    "kind": "LinkedField",
                                                                    "name": "scheduleShift",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Schedule",
                                                                            "kind": "LinkedField",
                                                                            "name": "schedule",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v3 /*: any*/),
                                                                                (v2 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v2 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "scheduleShiftId",
                                                                    "storageKey": null
                                                                },
                                                                (v17 /*: any*/),
                                                                (v5 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v26 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v27 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "filters": null,
                                            "handle": "connection",
                                            "key": "ScheduleShiftChangeTab_changeRequests",
                                            "kind": "LinkedHandle",
                                            "name": "changeRequests"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "9caf20040a5f8c224eba5962b465276e",
            "id": null,
            "metadata": {},
            "name": "ResetScheduleShiftConfirmResetScheduleShiftMutation",
            "operationKind": "mutation",
            "text": "mutation ResetScheduleShiftConfirmResetScheduleShiftMutation(\n  $model: ResetScheduleShiftRequestInput!\n) {\n  resetScheduleShift(model: $model) {\n    shiftEdge {\n      node {\n        ...ScheduleShiftInformationTab_ScheduleShift\n        ...useScheduleShiftAttachments_scheduleShift\n        ...useScheduleShiftNotes_scheduleShift\n        ...ScheduleShiftHistory_scheduleShift\n        ...ScheduleShiftChangeTab_shift\n        id\n      }\n    }\n  }\n}\n\nfragment AssetProficiencyValidationIcon_scheduleShiftAssetValidation on ScheduleShiftAssetValidation {\n  schedulableAsset {\n    asset {\n      id\n      name\n      assetNumber\n      validateProficiency\n    }\n    id\n  }\n  schedulableUser {\n    user {\n      fullName\n      id\n    }\n    id\n  }\n  userAssignmentType {\n    title\n    id\n  }\n  assetProficiency {\n    isValid\n  }\n}\n\nfragment AssignedEntity_ScheduleShift on ScheduleShift {\n  id\n  assignedEntity {\n    __typename\n    ... on ISchedulableEntity {\n      __isISchedulableEntity: __typename\n      id\n      displayName\n      color\n      ... on SchedulableUser {\n        user {\n          phone\n          employeeId\n          id\n        }\n      }\n    }\n    ...SchedulableEntityWithText_iScheduleableEntity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  scheduleAssignmentType {\n    resources(where: {schedulableEntity: {type: {eq: USER}}}) {\n      nodes {\n        schedulableEntity {\n          __typename\n          ... on SchedulableUser {\n            user {\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        id\n      }\n    }\n    id\n  }\n  schedule {\n    currentUserPermissions\n    id\n  }\n  ...RemoveAssignedEntity\n  ...UpdateAssignedEntityOnShift_scheduleShift\n  isVacant\n  status\n  ...ScheduleShiftAssetValidations_scheduleShift\n}\n\nfragment Avatar_iHaveAvatar on IHaveAvatar {\n  __isIHaveAvatar: __typename\n  avatar {\n    url(queryTransform: \"width=300&height=300&mode=crop&scale=both\")\n    id\n  }\n  ... on Asset {\n    color\n    name\n  }\n  ... on Company {\n    name\n  }\n  ... on User {\n    color\n    firstname\n    lastname\n  }\n}\n\nfragment EditScheduleShiftDescription on ScheduleShift {\n  id\n  description\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment EditScheduleShiftEvent on ScheduleShift {\n  id\n  assignmentTypeId\n  event {\n    id\n    name\n  }\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment EditScheduleShiftTimeEnd on ScheduleShift {\n  id\n  end\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment EditScheduleShiftTimeStart on ScheduleShift {\n  id\n  schedule {\n    currentUserPermissions\n    id\n  }\n  start\n}\n\nfragment RemoveAssignedEntity on ScheduleShift {\n  id\n  assignmentType {\n    title\n    id\n  }\n}\n\nfragment SchedulableEntityWithText_iScheduleableEntity on ISchedulableEntity {\n  __isISchedulableEntity: __typename\n  id\n  displayName\n  color\n  ... on SchedulableUser {\n    user {\n      employeeId\n      id\n    }\n  }\n}\n\nfragment SchedulableEntity_schedulableEntity on SchedulableEntity {\n  __isSchedulableEntity: __typename\n  ... on ISchedulableEntity {\n    __isISchedulableEntity: __typename\n    id\n    displayName\n  }\n}\n\nfragment ScheduleShiftAssetValidations_scheduleShift on ScheduleShift {\n  assetValidations {\n    ...AssetProficiencyValidationIcon_scheduleShiftAssetValidation\n    schedulableAsset {\n      asset {\n        validateProficiency\n        id\n      }\n      id\n    }\n    assetProficiency {\n      isValid\n    }\n  }\n}\n\nfragment ScheduleShiftChangeRequest_shift on ScheduleShiftChangeRequest {\n  comment\n  createdAt\n  end\n  id\n  requestedBy {\n    id\n    firstname\n    lastname\n  }\n  respondedAt\n  responseComment\n  respondedBy {\n    id\n    firstname\n    lastname\n  }\n  scheduleShift {\n    schedule {\n      currentUserPermissions\n      id\n    }\n    id\n  }\n  scheduleShiftId\n  start\n  status\n}\n\nfragment ScheduleShiftChangeTab_shift on ScheduleShift {\n  id\n  end\n  schedule {\n    currentUserPermissions\n    id\n  }\n  start\n  assignedEntity {\n    __typename\n    ... on SchedulableUser {\n      user {\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  changeRequests {\n    edges {\n      node {\n        id\n        status\n        requestedByUserId\n        ...ScheduleShiftChangeRequest_shift\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScheduleShiftEditBreaks_scheduleShift on ScheduleShift {\n  start\n  id\n  end\n  breaks {\n    end\n    start\n    type\n  }\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment ScheduleShiftFiles_scheduleShift on ScheduleShift {\n  ...useScheduleShiftAttachments_scheduleShift\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment ScheduleShiftHistoryAssigneeChange_history on ScheduleShiftHistoryAssigneeChange {\n  id\n  reasonEvent {\n    name\n    id\n  }\n  byUser {\n    ...User_user\n    id\n  }\n  newAssignedEntity {\n    __typename\n    ...SchedulableEntity_schedulableEntity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  previouslyAssignedEntity {\n    __typename\n    ...SchedulableEntity_schedulableEntity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  timestamp\n}\n\nfragment ScheduleShiftHistoryEventChange_history on ScheduleShiftHistoryEventChange {\n  id\n  newEvent {\n    name\n    id\n  }\n  previousEvent {\n    name\n    id\n  }\n  byUser {\n    ...User_user\n    id\n  }\n  timestamp\n}\n\nfragment ScheduleShiftHistoryStatusChange_history on ScheduleShiftHistoryStatusChange {\n  id\n  newStatus\n  previousStatus\n  byUser {\n    ...User_user\n    id\n  }\n  timestamp\n}\n\nfragment ScheduleShiftHistoryTimeChange_history on ScheduleShiftHistoryTimeChange {\n  id\n  byUser {\n    ...User_user\n    id\n  }\n  newEnd\n  newStart\n  originalBreaks {\n    start\n    end\n    type\n  }\n  newBreaks {\n    start\n    end\n    type\n  }\n  originalEnd\n  originalStart\n  timestamp\n}\n\nfragment ScheduleShiftHistoryVacancyInterestListItem_scheduleShiftHistoryVacancyInterest on ScheduleShiftHistoryVacancyInterest {\n  byUser {\n    ...UserSnippet_user\n    id\n  }\n  id\n  schedulableEntityId\n  scheduleShift {\n    id\n    assignedEntityId\n  }\n  status\n  timestamp\n}\n\nfragment ScheduleShiftHistoryVacancyInterestList_scheduleShiftHistoryVacancyInterestConnection on ScheduleShiftHistoryVacancyInterestConnection {\n  nodes {\n    ...ScheduleShiftHistoryVacancyInterestListItem_scheduleShiftHistoryVacancyInterest\n    id\n  }\n  totalCount\n}\n\nfragment ScheduleShiftHistoryVacancyInterest_history on ScheduleShiftHistoryVacancyInterest {\n  id\n  byUser {\n    ...User_user\n    id\n  }\n  description\n  schedulableEntity {\n    __typename\n    ...SchedulableEntity_schedulableEntity\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  status\n  timestamp\n}\n\nfragment ScheduleShiftHistory_scheduleShift on ScheduleShift {\n  id\n  history(order: {timestamp: DESC}) {\n    edges {\n      node {\n        __typename\n        ... on IHaveScheduleShiftHistory {\n          __isIHaveScheduleShiftHistory: __typename\n          id\n          timestamp\n          description\n          type\n          byUser {\n            ...User_user\n            id\n          }\n        }\n        ... on ScheduleShiftHistoryAssignmentTypeChange {\n          newAssignmentType {\n            id\n            title\n          }\n          previousAssignmentType {\n            id\n            title\n          }\n        }\n        ...ScheduleShiftHistoryAssigneeChange_history\n        ...ScheduleShiftHistoryVacancyInterest_history\n        ...ScheduleShiftHistoryTimeChange_history\n        ...ScheduleShiftHistoryEventChange_history\n        ...ScheduleShiftHistoryStatusChange_history\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ScheduleShiftInformationTab_ScheduleShift on ScheduleShift {\n  id\n  schedule {\n    currentUserPermissions\n    id\n  }\n  ...AssignedEntity_ScheduleShift\n  ...ShiftInformation_ScheduleShift\n  ...SimultaneousShifts_scheduleShift\n  ...ScheduleShiftFiles_scheduleShift\n  ...ScheduleShiftInterestForm_scheduleShift\n  isVacant\n  status\n  vacancyInterests {\n    ...ScheduleShiftHistoryVacancyInterestList_scheduleShiftHistoryVacancyInterestConnection\n  }\n}\n\nfragment ScheduleShiftInterestForm_scheduleShift on ScheduleShift {\n  id\n  currentVacancyInterestForEntity {\n    description\n    status\n    id\n  }\n}\n\nfragment ShiftInformation_ScheduleShift on ScheduleShift {\n  ...EditScheduleShiftTimeStart\n  ...EditScheduleShiftTimeEnd\n  ...EditScheduleShiftEvent\n  ...EditScheduleShiftDescription\n  ...useScheduleShiftTags_scheduleShift\n  ...ScheduleShiftEditBreaks_scheduleShift\n  assignmentTypeId\n  schedule {\n    currentUserPermissions\n    id\n  }\n}\n\nfragment SimultaneousShifts_scheduleShift on ScheduleShift {\n  simultaneousScheduleShift {\n    edges {\n      node {\n        id\n        assignedEntity {\n          __typename\n          ... on SchedulableUser {\n            user {\n              id\n            }\n          }\n          ... on SchedulableAsset {\n            asset {\n              id\n            }\n          }\n          ...SchedulableEntityWithText_iScheduleableEntity\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        assignmentType {\n          title\n          id\n        }\n        end\n        start\n        isVacant\n        status\n        ...ScheduleShiftAssetValidations_scheduleShift\n      }\n    }\n  }\n}\n\nfragment UpdateAssignedEntityOnShift_scheduleShift on ScheduleShift {\n  id\n  assignedEntityId\n  start\n  end\n  assignmentTypeId\n  assignmentType {\n    title\n    id\n  }\n  schedule {\n    assignmentTypes {\n      edges {\n        node {\n          id\n          assignmentTypeId\n          resources {\n            edges {\n              node {\n                schedulableEntity {\n                  __typename\n                  ... on ISchedulableEntity {\n                    __isISchedulableEntity: __typename\n                    id\n                    displayName\n                  }\n                  ... on Node {\n                    __isNode: __typename\n                    id\n                  }\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment UserNameLabel_user on User {\n  employeeId\n  fullName\n}\n\nfragment UserSnippet_user on User {\n  ...Avatar_iHaveAvatar\n  ...UserNameLabel_user\n  id\n}\n\nfragment User_user on User {\n  ...UserNameLabel_user\n  id\n}\n\nfragment useScheduleShiftAttachments_scheduleShift on ScheduleShift {\n  id\n  attachments {\n    edges {\n      node {\n        __typename\n        contentType\n        directory\n        id\n        name\n        size\n        storageId\n        url\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useScheduleShiftNotes_scheduleShift on ScheduleShift {\n  id\n  notes {\n    edges {\n      node {\n        id\n        byUser {\n          id\n          firstname\n          lastname\n        }\n        createdAt\n        text\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment useScheduleShiftTags_scheduleShift on ScheduleShift {\n  id\n  tags {\n    edges {\n      node {\n        __typename\n        id\n        tagId\n        tag {\n          name\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "f7ac09c2f258c712eb2a8284d411f6f4";
export default node;
